import { mergeWeeklyGuideTrackColorMap } from '../constants/weeklyLearningGuide';
import { getTracks } from '../services/gradeTrackService';
import { getWeeklyLearningGuideTrackColors } from '../services/weeklyLearningGuideTrackColorsService';
import type { Track } from '../types/domain';
import { getOrderedTrackNamesForGrade } from './trackOrderForGrade';

/**
 * 주간학습 안내 시간표 과목행과 동일: 편제명(트랙 표시명) → 저장된 색 또는 팔레트 기본값.
 */
export async function resolveWeeklyLearningGuideTrackBackgroundHex(params: {
  workspaceId: string;
  academicYear: number;
  gradeId: string;
  trackDisplayName: string;
  /** 있으면 추가 fetch 생략 */
  tracks?: Track[] | null;
}): Promise<string> {
  const { workspaceId, academicYear, gradeId, trackDisplayName } = params;
  const name = trackDisplayName.trim();
  if (!name || !workspaceId || !gradeId || !Number.isInteger(academicYear) || academicYear <= 0) return '';
  let tracks = params.tracks;
  if (!tracks?.length) {
    try {
      tracks = await getTracks(workspaceId);
    } catch {
      tracks = [];
    }
  }
  try {
    const ordered = getOrderedTrackNamesForGrade(workspaceId, gradeId, tracks);
    const saved = await getWeeklyLearningGuideTrackColors(workspaceId, academicYear, gradeId);
    const map = mergeWeeklyGuideTrackColorMap(ordered, saved);
    return (map[name] ?? '').trim();
  } catch {
    return '';
  }
}
